import { CheckboxInput } from '@calendly/ui/components/checkbox-input';
import classNames from 'classnames';
import { forwardRef } from 'react';
const checkboxLabelCss = "c3egghc";
const CheckboxLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(checkboxLabelCss, props.className)} />;
});
export const SelectCell = ({
  selectedRows,
  setSelectedRows,
  rowId,
  ...props
}) => {
  const index = selectedRows.indexOf(rowId);
  const isChecked = index !== -1;
  const toggleSelectedRow = () => {
    const newArray = [...selectedRows];
    if (isChecked) {
      newArray.splice(index, 1);
    } else {
      newArray.push(rowId);
    }
    setSelectedRows(newArray);
  };
  return <CheckboxLabel>
      <CheckboxInput {...props} onChange={toggleSelectedRow} checked={isChecked} />
    </CheckboxLabel>;
};

require("./select_cell.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./select_cell.js");